import axios from 'axios';
import { getCredentials } from '../_redux/_reducers'; // The selector is fine to import

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// This function will be called once from your main store setup file
export const setupAxiosInterceptors = (store, {logout}) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const state = store.getState();
      const credentials = getCredentials(state);

      if (credentials && credentials.email) {
        config.headers['uid'] = credentials.email;
        config.headers['access-token'] = credentials.accessToken;
        config.headers['client'] = credentials.client;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const errorData = error.response?.data;
      if (
        errorData?.errors &&
        Array.isArray(errorData.errors) &&
        (errorData.errors.includes("Authorized users only.") ||
          errorData.errors.includes("You need to sign in or sign up before continuing."))
      ) {
        console.warn("Authentication error detected by Axios interceptor. Logging out.");
        store.dispatch(logout("Your session has timed out, please log back in."));
      }

      // It's crucial to still reject the promise so that components waiting on the
      // API call know that it failed.
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;